import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { Link, useParams } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  ManageCheckLists,
  UpdateCheckLists,
} from "../../redux/action/checklists";
import { Formik } from "formik";
import { ToastContainer } from "react-toastify";
import { APIURL } from "../../redux/action/config";
import loader from "../../components/loader/loader";

const EditCheckLists = () => {
  const { id } = useParams();
  const [checkItems, setCheckItems] = useState();
  const [loading, setLoading] = useState(false);

  const checklist = useSelector((state) => state?.checklists?.list);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(ManageCheckLists());
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/checkListItem/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCheckItems(result?.data?.checklistchild);
        setLoading(false);
      })
      .catch((error) => console.log("error", error));
  }, [dispatch, id]);

  const checkdata = checklist?.data?.checklistparent
    ? checklist?.data?.checklistparent
    : "";
  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Edit Check Items" page="editchecklists">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            {!loading && checkItems?.id ? (
              <div className="row">
                <div className="col-xl-8 offset-xl-2">
                  <div className="card card-flush h-lg-100">
                    <div className="card-header pt-7">
                      <div className="card-title">
                        <span className="svg-icon svg-icon-1 me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                              fill="black"
                            ></path>
                            <path
                              opacity="0.3"
                              d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <h2>Add New Item</h2>
                      </div>
                    </div>
                    <div className="card-body pt-5">
                      <Formik
                        initialValues={{
                          name: checkItems?.name,
                          parentName: checkItems?.parentName,
                          details: checkItems?.details,
                          // status: checkItems?.status,
                        }}
                        onSubmit={(values) => {
                          values.name = values?.name
                            ? values?.name
                            : checkItems?.name;
                          values.parentName = values?.parentName
                            ? values?.parentName
                            : checkItems?.parentName;
                          values.details = values?.details
                            ? values?.details
                            : checkItems?.details;
                          // values.status = values?.status
                          //   ? values?.status
                          //   : checkItems?.status;
                          dispatch(UpdateCheckLists(values, id));
                        }}
                      >
                        {({
                          values,
                          handleBlur,
                          handleChange,
                          handleSubmit,
                        }) => (
                          <form className="form" onSubmit={handleSubmit}>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Name
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  name="name"
                                  id="name"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  defaultValue={
                                    values.name ? values.name : checkItems?.name
                                  }
                                />
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Parent category
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <select
                                  className="form-control form-control-solid"
                                  aria-label=".form-select-lg example"
                                  name="parentName"
                                  id="parentName"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  defaultValue={
                                    values.parentName
                                      ? values.parentName
                                      : checkItems?.parentName
                                  }
                                >
                                  <option selected>
                                    Select parent category
                                  </option>
                                  {checkdata
                                    ? checkdata?.map((item) => {
                                        return (
                                          <option
                                            value={item.name}
                                            selected={
                                              checkItems?.parentName ===
                                              item?.name
                                                ? true
                                                : false
                                            }
                                          >
                                            {item?.name}
                                          </option>
                                        );
                                      })
                                    : ""}
                                </select>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Details
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <textarea
                                  type="text"
                                  className="form-control form-control-solid"
                                  name="details"
                                  id="details"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  defaultValue={
                                    values.details
                                      ? values.details
                                      : checkItems?.details
                                  }
                                ></textarea>
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div>
                            {/* <div className="row mb-8">
                          <div className="col-xl-3">
                            <div className="fs-6 fw-bold mt-2 mb-3">
                              Status
                            </div>
                          </div>
                          <div className="col-xl-9 fv-row fv-plugins-icon-container">
                            <select
                              className="form-select form-control form-control-solid"
                              aria-label="Select example"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="status"
                              id="status"
                              defaultValue={
                                values.status
                                  ? values.status
                                  : checkItems?.status
                              }
                            >
                              <option>Select Status</option>
                              <option
                                value="active"
                                label="Active"
                                selected={
                                  checkItems?.status === "active"
                                    ? true
                                    : false
                                }
                              >
                                Active
                              </option>
                              <option
                                value="inactive"
                                label="Inactive"
                                selected={
                                  checkItems?.status === "inactive"
                                    ? true
                                    : false
                                }
                              >
                                Inactive
                              </option>
                            </select>
                            <div className="fv-plugins-message-container invalid-feedback"></div>
                          </div>
                        </div> */}
                            <div className="separator mb-6"></div>
                            <div className="d-flex justify-content-end">
                              <Link
                                to="/manage-checklists"
                                type="reset"
                                className="btn btn-light me-3"
                              >
                                Cancel
                              </Link>
                              <button type="submit" className="btn btn-primary">
                                <span className="indicator-label">Save</span>
                              </button>
                            </div>
                            <div></div>
                          </form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              loader()
            )}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default connect(null, { ManageCheckLists, UpdateCheckLists })(
  EditCheckLists
);
